<template>
  <div>
    <div class="blokk shimmer blokk-title">--</div>
    <div class="blokk shimmer blokk-subtitle">-----------</div>
    <div class="blokk shimmer blokk-status">-------- ----</div>
    <div class="blokk shimmer blokk-simple-line-chart">-------</div>
  </div>
</template>

<script>
export default {
  name: 'UsageStatsBlokk',
};
</script>

<style lang="scss" scoped>
@import '~scss/utilities/initial-variables.scss';
@import '~scss/utilities/derived-variables.scss';

.blokk-title,
.blokk-simple-line-chart {
  font-size: $size-1;
  line-height: 0.6;
}

.blokk-subtitle {
  font-size: 0.875%;
  line-height: 1.43;
}

.blokk-status {
  font-size: $size-small;
  line-height: 1.67;
}
</style>
